import { render, staticRenderFns } from "./ProductBuy.vue?vue&type=template&id=80e8b9be&scoped=true&"
import script from "./ProductBuy.vue?vue&type=script&lang=js&"
export * from "./ProductBuy.vue?vue&type=script&lang=js&"
import style0 from "./ProductBuy.vue?vue&type=style&index=0&id=80e8b9be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e8b9be",
  null
  
)

export default component.exports